<template>
    <div class="model-con" v-show="props.options && props.options.length">
        <!-- 标题 -->
        <div class="model-title-con" @click="() => (expand = !expand)">
            <p class="model-title">{{ categoryName }}</p>
            <div class="expand-btn-con">
                <p>{{ expand ? '收起' : '展开' }}</p>
                <el-icon v-if="expand">
                    <ArrowUp />
                </el-icon>
                <el-icon v-else>
                    <ArrowDown />
                </el-icon>
            </div>
        </div>
        <!-- 表单内容 -->
        <div v-show="expand" class="model-form-item-con">
            <el-form
                ref="formRef"
                :model="formData"
                label-width="80px"
                :rules="rules"
                style="width: 100%"
            >
                <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
                    <el-form-item
                        v-for="item in formItemList"
                        :key="item.categoryCode"
                        :label="item.categoryName"
                        :prop="item.categoryCode"
                    >
                        <el-select
                            v-model="formData[item.categoryCode]"
                            :placeholder="`点击选择${item.categoryName}`"
                            :teleported="false"
                            :clearable="item.categoryCode !== 'all_stage'"
                            popper-class="srt-select-popper"
                            :class="[
                                'form-item-select',
                                'srt-select',
                                {
                                    'srt-clear-select':
                                        item.categoryCode !== 'all_stage' &&
                                        formData[item.categoryCode],
                                },
                            ]"
                            @change="val => handleChange(val, item)"
                            @clear="handleClear(item)"
                        >
                            <el-option
                                v-for="opt in item.optionList"
                                :key="opt.id"
                                :value="opt.id"
                                :label="opt.optionName"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-row v-if="categoryCode === 'zyzx_stsj'">
                        <el-form-item
                            label="公开时间"
                            prop="visibleTime"
                            class="entire-line-item"
                            :inline-message="true"
                        >
                            <div class="publish-input-con">
                                <!-- <span>即日起</span>
                                <el-input
                                    v-model.number="
                                        formData.delayOpenTimeDuration
                                    "
                                    class="publish-time-input"
                                ></el-input>
                                <span>个月后公开</span> -->
                                <el-date-picker
                                    ref="visibleTimeRef"
                                    v-model="formData.visibleTime"
                                    type="datetime"
                                    placeholder="请选择公开时间"
                                    :shortcuts="shortcuts"
                                    :disabled-date="disabledDate"
                                    format="YYYY-MM-DD HH:mm"
                                    @focus="visibleTimeFocus"
                                />
                            </div>
                        </el-form-item>
                        <!--  -->
                        <p class="publist-tip">
                            由于试题试卷资源的特殊性，发布后可设置一段时间保密期再公开，默认6个月，可自行修改
                        </p>
                    </el-row>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script setup lang="ts">
import { cloneDeep } from 'lodash';
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue';
import { ref, reactive, onMounted, withDefaults, watch, computed } from 'vue';
import dayjs from 'dayjs';
type SelectItem = {
    categoryCode: string;
    categoryName: string;
    id: string;
    optionList: {
        id: string;
        optionCode: string;
        optionName: string;
    }[];
    parentTags: string;
    subCategoryList: SelectItem[];
};
type PropsType = {
    categoryCode: string;
    categoryName: string;
    tenant: string;
    brand: string;
    options: SelectItem[];
};
type IChooseCategoryOptionList = {
    categoryCode: string;
    optionCode: string;
    optionName: string;
};
type IEmitResult = {
    firstCategoryCode: string;
    chooseCategoryOptionList: IChooseCategoryOptionList[];
    visibleTime?: number;
};
const props = withDefaults(defineProps<PropsType>(), {
    categoryCode: undefined,
    categoryName: '',
    options: () => [],
    resultForm: () => [],
});
defineExpose({ getFormData });

const expand = ref(true);
const formRef = ref();
const formData = reactive({ visibleTime: new Date().getTime() });
const rules = reactive({
    all_stage: [{ required: true, message: '请选择学段' }],
    // delayOpenTimeDuration: [
    //     {
    //         required: false,
    //         validator: (rule, value, callback) => {
    //             if (value >= 0 && value <= 12) {
    //                 return Promise.resolve();
    //             } else {
    //                 return Promise.reject('试题试卷公开时间不可超出0-12个月');
    //             }
    //         }
    //     }
    // ]
});
const shortcuts = [
    {
        text: '今天',
        value: new Date(),
    },
    {
        text: '三个月后',
        value: () => {
            const date = new Date();
            let futherDate: any = dayjs().add(3, 'month');
            date.setTime(futherDate);
            return date;
        },
    },
    {
        text: '六个月后',
        value: () => {
            const date = new Date();
            let futherDate: any = dayjs().add(6, 'month');
            date.setTime(futherDate);
            return date;
        },
    },
    {
        text: '一年后',
        value: () => {
            const date = new Date();
            let futherDate: any = dayjs().add(1, 'year');
            date.setTime(futherDate);
            return date;
        },
    },
];
const visibleTimeRef: any = ref(null);
function disabledDate(date) {
    return date && date.valueOf() < Date.now() - 3600 * 1000 * 24;
}
function visibleTimeFocus() {
    // console.log(visibleTimeRef.value[0], '日期选择器');
    visibleTimeRef.value && visibleTimeRef.value[0].handleOpen();
}
// 用來存储真实的多级select数据
let storeOptions: SelectItem[] = [];
// 降维后的select
const formItemList = ref<SelectItem[]>([]);

// 广度优先的方式对select数据进行扁平化
const getFormatForm = (list: SelectItem[]) => {
    const res: SelectItem[] = [];
    const stash: SelectItem[][] = [];
    const formatter = (list: SelectItem[]) => {
        for (let item of list) {
            if (item.subCategoryList) {
                stash.push(item.subCategoryList);
            }
            const param: any = { ...item };
            delete param.subCategoryList;
            res.push(param);
        }
        const firstOfStash = stash.shift();
        firstOfStash && formatter(firstOfStash);
    };
    formatter(list);
    return res;
};

watch(
    () => props.options,
    () => {
        for (let item of props.options) {
            formData[item.categoryCode] = undefined;
        }
        // 存储options,并将options进行扁平化
        storeOptions = cloneDeep(props.options);
        formItemList.value = getFormatForm(storeOptions);
    },
    { immediate: true },
);

// 变更时查询下一集并更新表单
const handleChange = async (val, selectProps) => {
    const res = await G_transmit('getFilterCommunityAssetCategory', {
        name: 'getFilterCommunityAssetCategory',
        queries: {
            firstCategoryId: selectProps.topTagId || selectProps.parentTags,
            subCategoryId: selectProps.id,
            optionId: val,
            tenant: props.tenant,
            brand: props.brand,
        },
    });
    const activeItem = findActiveItem(storeOptions, selectProps.id);
    if (activeItem) {
        activeItem.subCategoryList = res.data.map(subItem => ({
            ...subItem,
            topTagId: selectProps.topTagId || selectProps.parentTags,
        }));
    }
    formItemList.value = getFormatForm(storeOptions);
};

// 获取最终表单结果
async function getFormData() {
    await formRef.value.validate();
    const chooseCategoryOptionList: IChooseCategoryOptionList[] = [];
    for (let item of formItemList.value) {
        if (formData[item.categoryCode]) {
            const activeOption = item.optionList.find(
                option => option.id === formData[item.categoryCode],
            );
            chooseCategoryOptionList.push({
                categoryCode: item.categoryCode,
                optionCode: activeOption?.optionCode || '',
                optionName: activeOption?.optionName || '',
            });
        }
    }
    const result: IEmitResult = {
        firstCategoryCode: props.categoryCode,
        chooseCategoryOptionList,
    };
    if (props.categoryCode === 'zyzx_stsj') {
        result.visibleTime = formData.visibleTime;
    }
    return result;
}

// 查询改变的select的原始数据
const findActiveItem = (list, val): SelectItem => {
    let res: any;
    const findMethod = list => {
        for (let i = 0; i < list.length; i++) {
            if (list[i].id === val) {
                res = list[i];
                return;
            } else {
                if (list[i].subCategoryList) {
                    findMethod(list[i].subCategoryList);
                }
            }
        }
    };
    findMethod(list);
    return res;
};

const handleClear = item => {
    console.log('item', item);
};
</script>
<style lang="scss" scoped>
.model-con {
    // background: #e2ebff;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #eff6ff;
    box-sizing: border-box;
    margin-bottom: 16px;
}

.model-title-con {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #eff6ff;
    padding: 0 20px;
    cursor: pointer;

    .model-title {
        color: var(--main-text-color);
        font-weight: bold;
    }

    .expand-btn-con {
        color: var(--color-gray);
        width: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover {
            color: var(--color-primary);
        }
    }
}

.model-form-item-con {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 20px 20px 14px 20px;

    .label-required {
        color: var(--input-error-color);
        margin-right: 3px;
    }
    .form-item-select {
        width: 100%;

        :deep(.el-input__wrapper) {
            height: 40px;
        }

        :deep(.el-input__wrapper .el-input__inner) {
            &::-moz-placeholder {
                color: #ccc;
            }

            &:-moz-placeholder {
                color: #ccc;
            }

            &:-ms-input-placeholder {
                color: #ccc;
            }

            &::-webkit-input-placeholder {
                color: #ccc;
            }
        }
    }
}
.publish-input-con {
    // width: 100%;
    color: var(--main-text-color);

    .publish-time-input {
        width: 100px;
        margin: 0 10px;
    }
}
.form-item-select {
    width: 100%;

    :deep(.el-input__wrapper) {
        height: 40px;
    }

    :deep(.el-input__wrapper .el-input__inner) {
        &::-moz-placeholder {
            color: #ccc;
        }

        &:-moz-placeholder {
            color: #ccc;
        }

        &:-ms-input-placeholder {
            color: #ccc;
        }

        &::-webkit-input-placeholder {
            color: #ccc;
        }
    }
}
</style>
